<template>
  <div>
    <b-row class="mt--5">
      <!--<b-col cols="3" class="border-right pr-5">
        <h3>Notifications Using the Default Template</h3>
        <div v-for="t in defaultTemplatesReminders" :key="t" class="pt-5">
          {{ t }}
        </div>
      </b-col>-->
      <b-col cols="8" class="pl-4 pr-5">
        <validation-observer v-slot="{ handleSubmit }">
          <form
            method="post"
            @submit.prevent="handleSubmit(updateDefaultTemplate)"
          >
            <b-row>
              <b-col>
                <h2>Default Template</h2>
                Below is the message that will be sent for notifications set to
                Default.
              </b-col>
              <b-col class="pl-3" md="auto">
                <b-form-checkbox
                  switch
                  v-model="state"
                  value="preview"
                  unchecked-value="edit"
                  >Preview</b-form-checkbox
                >
              </b-col>
            </b-row>
            <template v-if="state == 'edit'">
              <b-row class="pt-5">
                <b-col>
                  <base-input
                    rules="required"
                    label="Subject"
                    placeholder=""
                    name="subject"
                    v-model="myDefaultTemplate.subject"
                  >
                  </base-input>

                  <base-textarea
                    v-model="myDefaultTemplate.message"
                    label="Message"
                    name="message"
                    :rows="10"
                    rules="required"
                    maxlength="100"
                    placeholder="Enter the default template you want applied to all reminders that are marked as default"
                  ></base-textarea>

                  <b-button type="submit" class="mt-4" block
                    >Save Default Template</b-button
                  >
                </b-col>
              </b-row>
            </template>
            <template v-if="state == 'preview'">
              <br />
              <Preview :notification="myDefaultTemplate" :keyItems="keyItems" />
            </template></form
        ></validation-observer>
      </b-col>
      <b-col cols="4" class="border-left pl-5">
        <h3>Dynamic Fields</h3>
        Select to copy the dynamic field to your clipboard.
        <div class="pt-5">
          <a
            v-for="k in keyItems"
            :key="k.key"
            href="#"
            @click.prevent="copy(k.key)"
          >
            <span
              v-b-tooltip.hover.right
              :title="k.value"
              v-html="'' + k.key + ''"
            ></span
            ><br />
          </a></div
      ></b-col>
    </b-row>
  </div>
</template>

<script>
import Preview from "./preview";
export default {
  components: { Preview },
  props: {
    keyItems: null,
    defaultTemplate: null,
    defaultTemplatesReminders: null,
  },
  data() {
    return {
      state: "edit",
      myDefaultTemplate: null,
    };
  },
  created() {
    this.myDefaultTemplate = JSON.parse(JSON.stringify(this.defaultTemplate));
  },
  methods: {
    copy(key) {
      let t = key;

      navigator.clipboard.writeText(t).then(() => {
        this.$emitter.emit("success", { message: t + " copied to clipboard." });
        this.showSideBar = false;
      });
    },
    updateDefaultTemplate() {
      this.$emit("onDefaultTemplateUpdated", this.myDefaultTemplate);
    },
  },
};
</script>

<style></style>
